/**
 * F-locale-uk (CEO 2026-09-18, para o técnico Roman Peter) — UCRANIANO.
 *
 * Estratégia: tradução COMPLETA do que o técnico vê (login/auth, comuns e o
 * portal do técnico); todo o resto do ERP faz fallback para o FRANCÊS via
 * spread em messages.ts. Para estender a cobertura, adicione namespaces aqui.
 */

import type { Messages } from "./messages.js";
import type { PagesMessages } from "./messages.pages.js";

export const ukCommon: Messages["common"] = {
  loading: "Завантаження…",
  cancel: "Скасувати",
  submit: "Надіслати",
  back: "Назад",
  next: "Далі",
  previous: "Попередній",
  save: "Зберегти",
  close: "Закрити",
  logout: "Вийти",
  logoutPending: "Вихід…",
  showPassword: "Показати пароль",
  hidePassword: "Приховати пароль",
  requiredField: "Обов'язкове поле",
};

export const ukLangSwitcher: Messages["langSwitcher"] = {
  ariaLabel: "Мова",
};

export const ukAuth: Messages["auth"] = {
  subtitle: "Система управління",
  emailLabel: "Ел. пошта",
  emailPlaceholder: "vash@email.com",
  passwordLabel: "Пароль",
  passwordPlaceholder: "••••••••",
  newPasswordLabel: "Новий пароль",
  confirmPasswordLabel: "Підтвердьте пароль",
  nameLabel: "Повне ім'я",
  submitLogin: "Увійти",
  submitLoginPending: "Вхід…",
  submitForgot: "Надіслати посилання",
  submitForgotPending: "Надсилаю…",
  submitReset: "Скинути пароль",
  submitResetPending: "Скидаю…",
  submitAccept: "Прийняти запрошення",
  submitAcceptPending: "Приймаю…",
  forgotPasswordLink: "Забули пароль?",
  backToLoginLink: "Назад до входу",
  forgotTitle: "Відновлення пароля",
  forgotDescription: "Введіть свою ел. пошту, і ми надішлемо посилання для скидання пароля.",
  forgotSent: "Надіслано! Перевірте свою пошту.",
  resetTitle: "Встановити новий пароль",
  resetDescription: "Виберіть надійний пароль (мінімум 8 символів).",
  resetSuccess: "Пароль успішно змінено. Перенаправлення…",
  acceptTitle: "Прийняти запрошення",
  acceptDescription: "Створіть пароль, щоб завершити реєстрацію.",
  acceptSuccess: "Реєстрацію завершено! Перенаправлення…",
  errorPasswordsDoNotMatch: "Паролі не збігаються.",
  errorTokenInvalid: "Посилання недійсне або прострочене.",
};

export const ukTechPortal: PagesMessages["techPortal"] = {
  title: "Портал техніка",
  logout: "Вийти",
  rolePdr: "Технік PDR",
  roleMontador: "Монтажник",
  notTechnicianNote: "Ваш обліковий запис не має ролі техніка в жодній компанії.",
  notLinkedNote:
    "⚠ Обліковий запис ще не прив'язаний до картки техніка — зверніться до офісу (Техніки → редагувати → Обліковий запис порталу).",
  plateLabel: "Номерний знак авто",
  searchHint: "Введіть номерний знак АБО VIN для пошуку авто. Кнопка ⇄ перемикає між полями.",
  menuHome: "Головна",
  panelsTitle: "Деталі до ремонту",
  impactsWord: "вм'ятин",
  searchBtn: "Шукати",
  searching: "Пошук…",
  noResults: "Немає авто «до виконання» з цим номером. Перевірте номер або зверніться до офісу.",
  myCommissionPdr: "Ваша комісія (PDR)",
  myCommissionMontage: "Ваша комісія (Монтаж)",
  commissionTbd: "буде розраховано",
  montageShort: "Монтаж",
  claimPdrMontage: "Взяти PDR + Монтаж",
  claimPdr: "Взяти лише PDR",
  claimMontage: "Взяти розбирання",
  claimOkPre: "✓ Взято:",
  myCarsTitle: "Мої авто",
  filterWeek: "Останні 7 днів",
  filterThisWeek: "Цього тижня",
  filterMonth: "Останній місяць",
  filterAll: "Усі",
  statusPending: "До отримання",
  statusPaid: "Оплачені",
  rowPaid: "Оплачено",
  rowPaidPartial: "Частково оплачено",
  myCarsEmpty: "Ще немає взятих авто.",
  scanTitle: "Зчитати камерою",
  scanning: "Читаю фото…",
  scanFail:
    "Не вдалося прочитати фото — наблизьте, уникайте відблисків і спробуйте ще раз, або введіть вручну.",
  agendaTitle: "Розклад шантьє",
  agendaEmpty: "Найближчими днями нічого не заплановано.",
  claimDevisNoPanels:
    "Кошторис без таблиці деталей (імпортований до парсера — попросіть повторно завантажити PDF)",
  importTitle: "Імпортувати кошторис (PDF)",
  importHint:
    "Отримали на місці кошторис, якого немає в пошуку? Виберіть клієнта шантьє та надішліть PDF — авто з'явиться одразу, і ви зможете його взяти.",
  importClientPlaceholder: "— виберіть клієнта —",
  importPickBtn: "Вибрати PDF та імпортувати",
  importing: "Імпортую…",
  importOkPre: "Кошторис імпортовано:",
  importExistsPre: "Цей кошторис УЖЕ ІСНУЄ в Gestion — нічого не продубльовано. Авто:",
  importPanelsWord: "деталей",
  importReadFail: "Не вдалося прочитати файл — спробуйте вибрати ще раз (не із zip).",
  importNoClients:
    "До вас не прив'язано жодного клієнта — попросіть офіс налаштувати пару комісії.",
  recTitle: "Приймання авто (обов'язкове перед ремонтом)",
  recHint:
    "Дайте відповідь щодо франшизи та занотуйте наявні пошкодження. Керівник шантьє теж може це зробити — якщо вже зробив, авто прибуває розблокованим.",
  recHintNoPhotos:
    "Поза шантьє фото не потрібні: лише вкажіть, чи має авто вирахування франшизи (обов’язково), і беріть роботу.",
  commissionFixedBadge: "фіксована сума",
  camTitlePlate: "Номер",
  camClose: "Закрити",
  camTorch: "Ліхтарик",
  camStarting: "Відкриваю камеру…",
  camAimPlate: "Наведіть номер у рамку",
  camAimVin: "Наведіть VIN у рамку",
  camOffline: "Немає з'єднання — пробую ще.",
  camDenied:
    "Камеру заблоковано. Дозвольте камеру для цього сайту в налаштуваннях браузера. А поки введіть вручну.",
  camUnavailable: "Камера недоступна на цьому пристрої — введіть вручну.",
  camNotFound: "Немає в Gestion — продовжую читати.",
  camUseAnyway: "Все одно використати",
  camConflictPre: "VIN від",
  camConflictDevis: "але кошторис —",
  camPickOne: "Яке з цих авто?",
  camRetry: "Прочитати знову",
  camType: "Ввести вручну",
  parcOnlyPdr: "лише PDR",
  parcWithMontage: "PDR + демонтаж/монтаж",
  parcChoiceLater:
    "Сума визначається, коли ви берете авто, після приймання: лише PDR або PDR + демонтаж/монтаж.",
  readOnlyNote:
    "Обліковий запис лише для перегляду: ви бачите виконані авто та стан кожного платежу, але не можете нічого додавати чи змінювати.",
  pdrPendingNote: "Завершіть PDR цих авто, перш ніж брати інше:",
  pendingTasksTitle: "Завдання, що очікують",
  pendingTasksBtn: "Завдання, що очікують",
  pendingTasksClose: "Закрити",
  pendingTasksNone: "Немає завдань.",
  pendingTasksHint:
    "Можна закрити й переглядати свої авто, але не можна брати чи додавати нове авто, доки PDR не позначено завершеним.",
  prodTitle: "Моє виробництво",
  prodAllTime: "За весь час",
  prodCar: "авто",
  prodCars: "авто",
  prodPaid: "Оплачено",
  prodToReceive: "до отримання",
  prodTbdNote: "авто, суму яких ще не розраховано, не враховано",
  noticeTitle: "Повідомлення від офісу",
  noticeAckBtn: "Зрозуміло",
  noticeDoneBtn: "Зроблено",
  myTasksTitle: "Завдання від офісу",
  myTasksOverdue: "Прострочено",
  myTasksToday: "Сьогодні",
  myTasksDue: "Термін",
  myTasksDoneBtn: "Зроблено",
  myTasksLaterBtn: "Пізніше",
  myTasksHint:
    "Натисніть «Зроблено», коли завершите. Прострочене завдання залишається тут, доки його не виконано.",
  noticeAckHint: "Зрозуміло: повернеться при наступному вході · Зроблено: більше не з'являється.",
  noticeBlockedTitle: "Портал заблоковано",
  noticeBlockedHint: "Завершіть незавершені завдання або зверніться до офісу:",
  noticeBlockedWait: "Лише офіс може розблокувати портал (нове авто, імпорт кошторису та сканер).",
  devisNetOfFranchise: "франшизу вже вирахувано",
  openCarsTitle: "Авто, які ви почали і ще не завершили",
  openCarsNote:
    "Ваш PDR завершено, але збирання ще не зареєстровано. Завершіть авто: зареєструйте збирання або повідомте монтажника.",
  openCarsMontage: "збирання не зареєстровано · розбирання:",
  openCarsOpen: "Відкрити",
  montageExternalBtn: "Збирання виконала третя сторона (гараж)",
  montageExternalHint: "Ніхто з ES/BS не отримує оплату за цей етап.",
  montageExternalConfirm:
    "Підтвердити: збирання цього авто виконала третя сторона (гараж)? Ніхто з ES/BS не отримає за нього оплату.",
  montageExternalDone: "збирання виконала третя сторона (гараж)",
  phaseExternalShort: "третя сторона (гараж)",
  claimMontageOnly: "Взяти лише розбирання/збирання",
  filterSince: "З 01/05/2026",
  filterRange: "Діапазон дат",
  degarnissageGarageBtn: "Розбирання виконав гараж (третя сторона)",
  degarnissageGarageConfirm:
    "Підтвердити: розбирання та збирання цього авто виконав гараж? Ніхто з ES/BS не отримає за них оплату.",
  degarnissageGarageDone: "Розбирання зареєстровано як виконане гаражем.",
  openCarsNoMontage:
    "розбирання з кошторису не зареєстровано — візьміть його або вкажіть, що виконав гараж",
  recFranchiseQ: "Чи має авто знижку франшизи для клієнта?",
  recYes: "Так",
  recFranchiseStep: "1 · Франшиза — обов'язково",
  recFranchiseFirstHint: "Дайте відповідь щодо франшизи, щоб відкрити фото приймання.",
  recPhotosStep: "2 · Пошкодження та фото",
  recNo: "Ні",
  recAmountPh: "Сума франшизи (€ TTC)",
  recDamagesPh: "Наявні пошкодження/зламані деталі (необов'язково, через кому)",
  recSaveBtn: "Зберегти приймання",
  recSaving: "Зберігаю…",
  recSavedMsg: "Приймання збережено — авто розблоковане для ремонту.",
  recDoneLabel: "Приймання виконано",
  recFranchisePre: "Франшиза:",
  recNoFranchise: "без франшизи",
  repairedAtPre: "Взято в роботу",
  importAtelierPlaceholder: "— виберіть майстерню —",
  chkPhotoFront: "Перед",
  chkPhotoFrontRight: "Бік передній правий",
  chkPhotoFrontLeft: "Бік передній лівий",
  chkPhotoRearLeft: "Бік задній лівий",
  chkPhotoRearRight: "Бік задній правий",
  chkPhotoHood: "Капот",
  chkPhotoRear: "Зад",
  chkNextPhotoPre: "Наступне фото:",
  chkTakePhotoBtn: "Зробити фото",
  chkPhotoCameraBtn: "Камера",
  chkPhotoGalleryBtn: "Галерея",
  chkPhotoSourcePre: "Фото:",
  chkPhotoCancelBtn: "Скасувати",
  chkPhotosDone: "Фото завершені",
  chkFranchiseEditBtn: "Редагувати франшизу",
  devisHtLabel: "Кошторис HT",
  chkClaimQ: "Як ви будете ремонтувати це авто?",
  chkPhotoHoodLiner: "Обшивка капота",
  chkPhotoDoorTrim1: "Обшивка дверей 1",
  chkPhotoDoorTrim2: "Обшивка дверей 2",
  chkPhotoDoorTrim3: "Обшивка дверей 3",
  chkPhotoDoorTrim4: "Обшивка дверей 4",
  chkPhotoDoorTrim5: "Обшивка дверей 5",
  chkPhotoRearLight1: "Задній ліхтар 1",
  chkPhotoRearLight2: "Задній ліхтар 2",
  chkPhotoRearLight3: "Задній ліхтар 3",
  montagePhotosTitle: "Фото розбирання",
  montageHtLabel: "Монтаж HT",
  worklogTitle: "Worklog (PDF)",
  worklogPdfBtn: "Завантажити PDF",
  worklogEmpty: "Без робіт цього тижня.",
  worklogWeekPre: "Тиждень",
  importAtelierLabel: "Майстерня / місце ремонту",
  // F2 checklist — керовані фото + підпис
  chkTitle: "Чек-лист автомобіля",
  chkIncompleteHint: "Чек-лист неповний — заповніть пункти нижче, щоб розблокувати ремонт.",
  chkCompleteBadge: "Чек-лист завершено",
  chkMileageLabel: "Пробіг (км)",
  chkMileagePh: "Напр.: 45200",
  chkPareBriseLabel: "Лобове скло",
  chkCielLabel: "Стеля салону (ciel de toit)",
  chkOkBtn: "OK",
  chkCrackedBtn: "Тріщина",
  chkDefectBtn: "З дефектом",
  chkPhotosTitle: "Фото автомобіля (обов'язкові)",
  chkPhotoAngle1: "Перед лівий",
  chkPhotoAngle2: "Перед правий",
  chkPhotoAngle3: "Зад лівий",
  chkPhotoAngle4: "Зад правий",
  chkPhotoRoof: "Дах",
  chkPhotoDashboard: "Панель приладів (запалювання увімкнене)",
  chkPhotoWindshield: "Лобове з тріщиною",
  chkPhotoHeadliner: "Стеля з дефектом",
  chkPhotoFree: "Додаткове фото",
  chkPhotoTake: "Зняти",
  chkUploading: "Завантаження…",
  chkSignTitle: "Підпис клієнта",
  chkSignHint: "Підпишіться пальцем у білій рамці",
  chkSignNamePh: "Ім'я підписанта",
  chkSignClear: "Очистити",
  chkSignedBadge: "Підпис збережено",
  chkSaveBtn: "Зберегти чек-лист",
  chkSaving: "Зберігаю…",
  chkSavedMsg: "Чек-лист збережено.",
  importPhotoBtn: "Імпорт із фото / скриншота",
  importPhotoReading: "Читаю фото…",
  importPhotoHint:
    "Скриншот працює краще, ніж фото паперу. Зчитування відбувається на вашому пристрої; перший раз завантажується зчитувач (~6 МБ).",
  importPhotoFail: "Не вдалося прочитати кошторис на фото — спробуйте чіткіший скриншот або PDF.",
  claimFranchisePre: "Франшиза",
  claimFranchiseSuf: "вирахувана з бази розрахунку — кошторис незмінний.",
  claimFranchiseSufParticular:
    "приватний клієнт: рахунок повний (авуар); комісії з зменшеної бази.",
  impersonatingPre: "Перегляд як",
  impersonatingBy: "від",
  impersonatingExit: "Завершити перегляд",
  claimNoMontage: "Цей кошторис без розбирання — для збиральника тут немає роботи.",
  otherCarsTitle: "Цей номер уже в Gestion, але без кошторису:",
  otherCarsWith: "з",
  otherCarsHint:
    "Щоб взяти це авто, потрібен кошторис — завантажте PDF нижче або зверніться до офісу.",
  montageEndPhotosTitle: "Фото після роботи",
  phaseDemontageTitle: "Розбирання",
  phaseMontageTitle: "Збирання",
  phaseDemontageBtn: "Розбирання завершено",
  phaseMontageBtn: "Збирання завершено",
  phaseDemontageDone: "Розбирання зроблено",
  phaseMontageDone: "Збирання зроблено",
  chkMarkDefect: "Деталь уже несправна",
  chkMarkBroken: "Зламалася під час роботи",
  chkClearIssue: "Зняти позначку",
  chkRetakePhoto: "Перезняти фото",
  chkIssueNotePlaceholder: "Що не так? (необов'язково)",
  chkIssuesDefectSummary: "деталь(і) вже несправні",
  chkIssuesBrokenSummary: "деталь(і) зламані під час роботи",
  deposeReposeLabel: "Зняти/Встановити",
  docsBannerTitle: "Бракує ваших документів",
  docsDaysLeftPre: "У вас ще",
  docsDaysLeftSuf: "днів, щоб їх надіслати.",
  docsOverdue: "Термін минув — надішліть сьогодні.",
  docsLastDay: "Останній день терміну.",
  docsIdentity: "Документ, що посвідчує особу",
  docsUrssaf: "Attestation URSSAF або сертифікат A1",
  docsRcPro: "Страхування RC Pro",
  docsKbis: "Kbis / auto-entrepreneur",
  docsSendBtn: "Надіслати",
  docsSentBadge: "надіслано",
  docsSending: "Надсилання…",
  docsA1: "Сертифікат A1 або attestation URSSAF",
  docsKbis2: "Kbis або реєстрація компанії (статут)",
  docsIdentity2: "Посвідчення особи",
  openCarBtn: "Відкрити авто",
  phaseDemontageByPre: "Знято",
  phaseMontagePending: "залишається встановлення",
  phaseBothDoneBy: "Зняття та встановлення виконав",
  takeMontageBtn: "Взяти встановлення",
  takeDemontageBtn: "Взяти зняття",
  takeHint: "Ви отримуєте половину цього етапу за вашим відсотком з клієнтом.",
  claimedAlready: "Ви вже взяли це авто",
  commissionDemontage: "Зняття",
  commissionMontageHalf: "Встановлення",
  commissionPendingHint: "залишилось",
  servicesTitle: "Послуги цього авто",
  servicePdrLabel: "PDR",
  showPhotosBtn: "Показати фото",
  hidePhotosBtn: "Сховати фото",
  photosReception: "Приймання",
  photosDemontage: "Зняття",
  photosMontageEnd: "Кінець роботи",
  carRepairedTitle: "Авто вже відремонтоване",
  carRepairedHint: "Усі роботи по цьому авто завершені.",
  carClosedNoTechTitle: "Авто видане без призначеного техніка",
  carClosedNoTechHint:
    "Керівник зафіксував видачу, але ніхто не взяв це авто в порталі. Повідомте офіс, щоб призначити техніка в досьє — лише тоді авто потрапить до вашого списку та оплати.",
  docsAllDone: "Документи повні. Дякуємо.",
  chkMissingPre: "Бракує:",
  chkMissingPhoto: "фото",
  chkMissingPhotos: "фото",
  chkMissingSignature: "підпис клієнта",
  chkMissingPareBrise: "відповісти про лобове скло",
  chkMissingCiel: "відповісти про стелю",
  rowDemontageDone: "розібрано",
  rowMontageDone: "зібрано",
  foundInOtherCompanyPre: "Цей автомобіль у компанії",
  switchCompanyBtn: "Перейти до",
  noPairTitle: "Авто знайдено, але воно вам не доступне",
  alreadyInvoicedTitle: "Послугу для цього авто вже виставлено в рахунку",
  alreadyInvoicedHint:
    "Попередній ремонт закрито. Якщо авто повернулося на новий ремонт, новий devis має потрапити в Gestion (через офіс або кнопкою імпорту devis нижче); після цього воно з'явиться тут, і ви зможете його взяти.",
  noPairHint:
    "Цей автомобіль належить клієнту, з яким у вас не налаштовано пару, і клієнт не прив'язаний до об'єкта, де у вас вона є. Попросіть офіс налаштувати пару або прив'язати клієнта до об'єкта.",
  phaseDoneDemontageMsg: "Авто розібрано",
  phaseDoneMontageMsg: "Авто зібрано",
  phaseDoneDemontageHint: "Вже у вашому списку як розібране. Залишилося збирання.",
  phaseDoneMontageHint: "Роботу з цим авто завершено.",
  claimNeedsReception: "Збережіть приймання вище, щоб взяти авто.",
  photoUploadFailPre: "Фото не завантажилося:",
  chkPhotoHeadlinerFront: "Стеля — перед",
  chkPhotoHeadlinerRear: "Стеля — зад",
  claimDemontageQ: "Взяти розбирання?",
  claimDemontageHint: "Збирання залишається за вами, якщо інший технік не візьме його.",
  takeOwnMontageBtn: "Взяти збирання",
  takeOwnMontageHint:
    "Розбирання завершено. Візьміть збирання, коли почнете його — до того інший технік може його взяти.",
  phaseMontageAfterDemontage: "2 · Збирання — після завершення розбирання.",
  toastPdrStarted: "Роботу PDR розпочато",
  toastPdrDone: "Роботу PDR завершено",
  toastDemontageTaken: "Розбирання взято",
  toastDemontageDone: "Розбирання завершено",
  toastMontageDone: "Збирання завершено",
  pdrDoneQ: "PDR цього автомобіля завершено?",
  pdrDoneBtn: "Позначити PDR завершеним",
  mycarsMarkPhasesBtn: "Позначити демонтаж / монтаж (відкриває авто)",
  importChantierHint:
    "Клієнт береться з імені у кошторисі та додається до об'єкта. Використовуйте для приватного клієнта.",
  recWaitingTitle: "Очікування приймання",
  recWaitingHint:
    "На об'єкті приймання (франшиза, чек-лист, фото та підпис) виконує керівник або старший технік; поза об'єктом — технік PDR цього авто. Після цього ви зможете взяти роботу.",
  recIncompleteWait:
    "Приймання не завершене — той, хто його робив (керівник, старший або технік PDR), має завершити його, перш ніж ви візьмете роботу.",
  importScanReading: "Сканований PDF — читання тексту через OCR на пристрої…",
  importScanPlatePrompt: "Номер, прочитаний з кошторису — підтвердьте або виправте перед імпортом:",
  importScanConfirmBtn: "Імпортувати з цим номером",
  importScanCancelBtn: "Скасувати",
  importScanFail:
    "Не вдалося прочитати сканований PDF. Сфотографуйте кошторис при хорошому освітленні та скористайтеся кнопкою фото.",
  scanWarn_scan_ocr:
    "Сканований кошторис прочитано OCR — перевірте номер, клієнта та суми за документом.",
  scanWarn_scan_dsp_derived: "Total DSP обчислено з Total HT (OCR не прочитав поле DSP).",
  scanWarn_scan_deg_adjusted:
    "Dégarnissage скориговано за Total HT (поле було нечитабельним для OCR).",
  scanWarn_scan_no_panels: "Деталі та вм'ятини не витягнуто зі схеми (сканований кошторис).",
  scanWarn_plate_confirmed: "Номер підтверджено вами.",
  scanWarn_scan_plate_ocr: "Номер прочитано OCR — перевірте.",
  scanWarn_scan_no_plate: "Номер не знайдено в документі.",
  scanWarn_scan_no_client: "Ім'я клієнта не визначено.",
  scanWarn_scan_no_date: "Дату кошторису не розпізнано.",
  scanWarn_scan_ht_from_ttc: "Total HT обчислено з TTC.",
  scanWarn_scan_ht_from_sum: "Total HT обчислено як суму позицій.",
  scanWarn_scan_sum_mismatch: "Сума позицій відрізняється від Total HT — перевірте документ.",
  scanWarn_num_from_filename: "Номер кошторису взято з назви файлу.",
  scanWarn_make_model_backfilled: "Марку/модель авто заповнено з кошторису.",
  scanWarn_devis_linked_existing: "Номер кошторису прив'язано до наявної справи.",
  scanWarn_car_existed: "Авто вже було в Gestion — справу доповнено, нічого не продубльовано.",
  scanWarn_customer_created: "Створено нового клієнта з кошторису.",
  scanWarn_customer_matched: "Клієнта зіставлено з наявним записом.",
  parcImportPdfBtn: "Імпортувати PDF кошторису",
  parcCarBtn: "Авто з парку",
  parcNoneHint: "Жоден ваш клієнт не має категорій авто з парку — зверніться до офісу.",
  parcPlateLabel: "Номер:",
  parcChooseClient: "— оберіть клієнта —",
  parcChooseCategory: "— оберіть категорію —",
  parcYouReceive: "ви отримуєте",
  parcChooseAtelier: "— оберіть майстерню —",
  parcMakePh: "Марка",
  parcModelPh: "Модель",
  parcCreateBtn: "Зареєструвати авто з парку",
  parcCreatedPre: "Авто з парку зареєстровано — виконайте приймання:",
  // F-portal-busca-primeiro (auditoria UX, item 7)
  modePlate: "Номер",
  searchCarBtn: "Знайти авто",
  importLink: "або імпортувати кошторис (PDF)",
  weekWord: "Тиждень",
  sitInRepair: "У ремонті",
  sitMontage: "Монтаж попереду",
  sitDone: "Завершено · до отримання",
  navCars: "Авто",
  navWorklog: "Worklog",
  navScanner: "Сканер",
  navPayments: "Виплати",
  navMore: "Більше",
  periodAria: "Період",
  statusAria: "Статус оплати",
  menuBtnAria: "Меню",
  advTitle: "Аванси до вирахування",
  advHint:
    "Компанія авансувала ці суми. Вирахуйте загальну суму у вашому наступному рахунку (лист із проформою вже показує очікувану суму).",
  advNoneOpen: "Відкритих авансів немає.",
  advHistory: "вже вирахувано",
  advDeductedIn: "вирахувано в",
};

export const ukLanding: Messages["landing"] = {
  navCta: "Увійти в систему",
  techSignupLink: "Я технік — створити акаунт",
  heroEyebrow: "Фінансова ERP · débosselage",
  heroTitlePre: "Від справи до бухгалтера,",
  heroTitleAccent: "усе в одному місці.",
  heroSubtitle:
    "Комісії, виставлення рахунків, банківська звірка та французька звітність — кілька компаній, у реальному часі. Система керування, створена для ремонту градових пошкоджень групи Storm.",
  featuresTitle: "Усе, що потрібно операції",
  featuresSubtitle:
    "Від приймання автомобіля до закриття обліку — один потік, без окремих таблиць.",
  f1t: "Справи та комісії",
  f1d: "Кожен ремонт в одному місці: рядки послуг, каскад комісії (клієнт · технік · посередник) і прогнозований прибуток у реальному часі.",
  f2t: "Повне виставлення рахунків",
  f2d: "Рахунки клієнта, техніка та всередині групи (proforma) — автоматичний PDF, надсилання поштою та кредит-ноти.",
  f3t: "Банківська звірка",
  f3d: "Імпортуйте виписку та звіряйте за кілька кліків: надходження, платежі, податки й комісії — з доданими документами.",
  f4t: "Французький облік",
  f4d: "SIG, Seuil, Bilan, ПДВ і бюджети у французькому форматі — готові для cabinet comptable.",
  f5t: "Всередині групи (intercompany)",
  f5d: "Рахунки між компаніями групи з автоматичним дзеркаленням і узгодженими правилами комісії.",
  f6t: "Звіти для бухгалтера",
  f6d: "Звірена виписка та звіт по рахунках у PDF/CSV, з посиланнями на документи — одним кліком.",
  f7t: "Кілька компаній",
  f7d: "Керуйте кількома компаніями групи одним перемикачем, з ізольованими даними та рівнями доступу.",
  f8t: "Багатомовність",
  f8d: "Інтерфейс французькою, португальською, іспанською, українською та англійською; документи для бухгалтера — французькою.",
  b1t: "Менше таблиць, більше контролю",
  b1d: "Від кошторису до оплати все пов'язано — без подвійної роботи та розкиданих даних.",
  b2t: "Готово для Франції",
  b2d: "ПДВ (зокрема зворотне нарахування), SIG/Bilan і звіти у форматі, який очікує бухгалтер.",
  b3t: "Безпечно та з аудитом",
  b3d: "Рівні доступу (super admin · admin · користувач · спостерігач) і повний журнал аудиту.",
  finalTitlePre: "Готові керувати всім",
  finalTitleAccent: "на одній панелі?",
  finalSubtitle: "Увійдіть з акаунтом групи Storm і почніть.",
  footerRights: "Усі права захищено",
};

export const ukTechSignup: PagesMessages["techSignup"] = {
  subtitle: "Реєстрація техніка",
  intro: "Заповніть свої дані. Euro Storm перевірить їх і відкриє доступ до порталу.",
  nameLabel: "Повне ім'я",
  emailLabel: "Електронна пошта",
  emailHint: "Це буде ваш логін. Туди надійде посилання для створення пароля.",
  phoneLabel: "Телефон / WhatsApp",
  langLabel: "Мова порталу",
  roleLabel: "Чим ви займаєтесь",
  roleDebosselage: "Технік PDR (débosselage)",
  roleMontage: "Монтажник (зняття та встановлення)",
  countryLabel: "Країна, де ви працюєте",
  submitBtn: "Надіслати реєстрацію",
  sending: "Надсилання…",
  successTitle: "Реєстрацію надіслано.",
  successBody:
    "Euro Storm перевірить ваші дані. Після схвалення ви отримаєте лист для створення пароля.",
  docsNotice:
    "Після схвалення портал попросить ваші документи: посвідчення особи, Kbis або рівнозначний документ і — залежно від країни проживання — документ URSSAF (для резидентів Франції) або сертифікат A1. У вас є 7 днів; робота через це не зупиняється.",
  backToLogin: "У мене вже є акаунт",
  residenceLabel: "Країна проживання / дозвіл на роботу",
  residenceHint: "Це визначає, які документи ми попросимо потім.",
  errorRequired: "Заповніть ім'я, пошту, телефон і країну.",
};
